import { SubjectMessages } from "@/messages/subject/subject.messages";

export const SUBJECT_TABLE_COLUMNS = (messages: SubjectMessages) => {
  return [messages.idColumn, messages.subjectColumn, messages.optionsColumn];
};
